<div *ngIf="data === 'additional'"> 
 <div class="alert-header">
    <h6 class="custom-model-heading">Reason for Additional Account</h6>
    <div class="close-btn hide">
      <button class="hide">
        <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon>
      </button>
    </div>
  </div>
  <p class="subheading">Please select one of these options:</p>
  <button [appAutoFocus]="true" ></button>
  <mat-radio-group  [(ngModel)]="selectedValue" color="primary" class="account-selection" disableRipple
    aria-label="Select an option" (ngModelChange)="toggleMethod()">
    <mat-radio-button  *ngFor="let opt of options" [value]="opt">{{ opt?.label }}
    </mat-radio-button>
  </mat-radio-group>

  <div class="secondary-selection" *ngIf="hideSubHeading">
    <p class="subheading">Specify one of the following:</p>
    <mat-radio-group [(ngModel)]="secondSelectedValue" color="primary" class="account-selection" disableRipple
      aria-label="Select an option" (ngModelChange)="subtoggleMethod()">
      <mat-radio-button *ngFor="let optSub of suboptions" [value]="optSub">{{ optSub?.label }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>

<div *ngIf="data === 'chat'">
  <div class="secondary-selection">
    <p class="subheading">Select the chat this additional account is for:</p>
    <mat-radio-group [(ngModel)]="selectedChatCust" color="primary" class="account-selection" disableRipple
      aria-label="Select an option" (ngModelChange)="changeCustomer()">
      <mat-radio-button *ngFor="let opt of activeChatCustomers"  [value]="opt">{{ opt?.title | titlecase }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>

<div class="custom-overlay-footer">
  <f-button text="Cancel" title="Cancel" type="button" variant="action" (buttonClicked)="typeHeadChange($event)">
  </f-button>
  <f-button text="Continue" title="Continue" type="button" variant="progressive" [disabled]="disable"
    (buttonClicked)="typeHeadChange($event)"></f-button>
</div>